import { render, staticRenderFns } from "./AgendamentoProtocolo.vue?vue&type=template&id=50bb25d2&scoped=true&"
import script from "./AgendamentoProtocolo.vue?vue&type=script&lang=js&"
export * from "./AgendamentoProtocolo.vue?vue&type=script&lang=js&"
import style0 from "./AgendamentoProtocolo.vue?vue&type=style&index=0&id=50bb25d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50bb25d2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCol,VIcon,VProgressCircular,VRow,VSkeletonLoader,VTooltip})
